export const VERIFICATION_STATUSES = {
    verified: {
        label: 'Verified',
        color: '#1CBB8C',
        backgroundColor: '#E8F8F3',
        icon: 'ri-checkbox-circle-fill',
    },
    received: {
        label: 'Received',
        color: '#2F80ED',
        backgroundColor: '#D9E9FF',
        icon: 'ri-inbox-archive-line',
    },
    pulled_from_api: {
        label: 'Pulled from API',
        color: '#2F80ED',
        backgroundColor: '#D9E9FF',
        icon: 'ri-inbox-archive-line',
    },
    available: {
        label: 'Available',
        color: '#1CBB8C',
        backgroundColor: '#E8F8F3',
        icon: 'ri-checkbox-circle-fill',
    },
    requested: {
        label: 'Requested',
        color: '#F2994A',
        backgroundColor: '#FFF4E5',
        icon: 'ri-time-line',
    },
    unverified: {
        label: 'Unverified',
        color: '#EB5757',
        backgroundColor: '#FFEAEA',
        icon: 'ri-close-circle-line',
    },
    not_requested: {
        label: 'Not Requested',
        color: '#828282',
        backgroundColor: '#F5F5F5',
        icon: 'ri-subtract-line',
    },
    not_available: {
        label: 'Not Available',
        color: '#BDBDBD',
        backgroundColor: '#F5F5F5',
        icon: 'ri-indeterminate-circle-line',
    },
};

export const getVerificationStatusConfig = (status) => {
    return VERIFICATION_STATUSES[status] || VERIFICATION_STATUSES.not_available;
};
